import { createContext } from 'react';
export var ScalprumContext = createContext({
    initialized: false,
    config: {},
    api: undefined,
});
//# sourceMappingURL=scalprum-context.js.map